export const PRODUCTION_MODE = process.env.REACT_APP_ENV === 'production';

export const BASE_URL = process.env.REACT_APP_BASE_URL ?? '';

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN ?? '';

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ?? '';